"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DuplexBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const DuplexBanner_module_scss_1 = __importDefault(require("./DuplexBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
function DuplexBanner({ title, ctaText, ctaLink, clickUrl, impressionUrl, logoImage, description, desktopImage, accessibilityText, logoAccessibilityText, associatedAdvertId, }) {
    return (react_1.default.createElement("a", { href: ctaLink, className: DuplexBanner_module_scss_1.default.bannerLink, "data-testid": "nav-flyout-duplex-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        } },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { type: "image/webp", srcSet: `
            ${desktopImage}?w=339&h=113&fmt=webp 1x,
            ${desktopImage}?w=678&h=226&fmt=webp 2x
          ` }),
            react_1.default.createElement("img", { "data-testid": "nav-flyout-duplex-banner-image", src: `${desktopImage}?w=339&h=113&fmt=auto`, srcSet: `
            ${desktopImage}?w=339&h=113&fmt=auto 1x,
            ${desktopImage}?w=678&h=226&fmt=auto 2x
          `, className: DuplexBanner_module_scss_1.default.image, alt: accessibilityText, loading: "lazy", decoding: "async" })),
        react_1.default.createElement("div", { className: DuplexBanner_module_scss_1.default.content },
            react_1.default.createElement("p", { "data-testid": "nav-flyout-duplex-banner-title", className: DuplexBanner_module_scss_1.default.title }, title.substring(0, 38)),
            description && (react_1.default.createElement("p", { "data-testid": "nav-flyout-duplex-banner-description", className: DuplexBanner_module_scss_1.default.description }, description.substring(0, 64)))),
        react_1.default.createElement("div", { className: DuplexBanner_module_scss_1.default.logoContainer },
            react_1.default.createElement("img", { src: logoImage, className: DuplexBanner_module_scss_1.default.logo, alt: logoAccessibilityText, "data-testid": "nav-flyout-duplex-banner-logo" })),
        react_1.default.createElement("div", { className: DuplexBanner_module_scss_1.default.ctaContainer },
            react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", className: DuplexBanner_module_scss_1.default.cta, labelText: ctaText, "data-testid": "nav-flyout-duplex-banner-cta" }))));
}
